import { axiosInstance } from "../client";
import { EmailSent } from "@rumble-it/common-lib/types/models/EmailSent.interface";

export const fetchEmailSentDetailsById = async (
  id: string,
): Promise<EmailSent> =>
  axiosInstance
    .get(`/admin/emails/sent/${id}`)
    .then((response) => response.data);
